import { useCallback, useEffect, useState } from "react";
import useDebounce from "./useDebounce";

const useResizer = (debouncedDelay = 250) => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setWindowDimensions({ width, height });
  }, [setWindowDimensions]);

  const debouncedHandleResize = useDebounce(handleResize, debouncedDelay);

  const setupResizer = useCallback(() => {
    window.addEventListener("resize", debouncedHandleResize);
  }, [debouncedHandleResize]);

  const cleanupResizer = useCallback(() => {
    window.removeEventListener("resize", debouncedHandleResize);
  }, [debouncedHandleResize]);

  useEffect(() => {
    setupResizer();
    return () => {
      cleanupResizer();
    };
  }, [setupResizer, cleanupResizer]);

  return { windowDimensions };
};

export default useResizer;
